import { Button, CircularProgress } from '@material-ui/core';

import React from 'react';
import ShippingAddressFormFields from 'components/ShippingAddress/ShippingAddressFormFields';

const ShippingAddressForm = (props) => {
  const {
    buttonText, handleSubmit, submitting, isValid, message,
  } = props;

  return (
    <div className='form-wrapper'>
      <form onSubmit={handleSubmit} className='address-form-wrapper'>
        <ShippingAddressFormFields {...props} />
        <div className='form-controls'>
          <Button
            variant='contained'
            color='secondary'
            type='submit'
            id='shipping-tab-button'
            fullWidth
            disabled={!isValid || submitting === true}
          >
            {submitting === false ? buttonText : <CircularProgress size={20} />}
          </Button>
        </div>
        {!message.hasMessage ? null : <p className='error'>{message.message}</p>}
      </form>
    </div>
  );
};

export default ShippingAddressForm;
